import { mapEnumToOptions } from '@abp/ng.core';

export enum ServiceEntrySheetState {
  Pending = 0,
  Generated = 1,
  Reversed = 2,
}

export const serviceEntrySheetStateOptions = mapEnumToOptions(ServiceEntrySheetState);
